import React, { useState, useEffect } from "react";
import { ArrowForward, BoltOutlined, ChatBubbleOutline, ChevronRight } from "@mui/icons-material"
import { Button, Modal, Skeleton } from "@mui/material"
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import fetch from "../Utils/fetch";
import _ from 'lodash';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./../Utils/styles.css"
import Countdown from 'react-countdown';
import { useNavigate } from "react-router-dom";
import { getsessionuser } from "../Utils/sessions";
import SignIn from "../Common/login";
import Universalheader from "../Headers/universalheader";
import Productsfour from "../Products/productsfour";
import { setAlert } from "../../store/alert";
import { setRecentlyViewed } from "../../store/recentlyViewed";
import { removeFromStore } from "../Utils/fn";
import ProductSlider from "../Products/ProductSlider";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { addSubProduct } from "../../store/subProducts";
import Homesliders from "./homesliders";
import Categoriesslider from "./categoriesslider";
import Searchbar from "../Components/searchbar";
import MobileCategorySection from "./MobileCategorySection";


const Home = ({ onrefresh }) => {

    const navigate = useNavigate()
    const [showsearchbar, setshowsearchbar] = useState(false);
    const dispatch = useDispatch();


    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0); // Set to 00:00:00 of the current day
    const diff = midnight - now;

    const sliders = useSelector((state) => state.webSettings.data.WEB_SITE_SLIDERS);
    const categories = useSelector((state) => state.categories.data);
    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
    const recentlySearched = useSelector((state) => state.recentlySearched.data);
    const webSettings = useSelector((state) => state.webSettings.data);
    const favorites = useSelector(state => state.favorites.data);
    const homeCategories = useSelector(state => state.homeCategories.data);
    const locationData = useSelector((state) => state.location.data);
    const [conditions, setconditions] = useState([]);

    const fullName = webSettings.FULL_NAME;
    const sitename = fullName?.split(' ')[0];

    const [topSellingProducts, settopSellingProducts] = useState([]);


    const [categoriesGroups, setCategoriesGroups] = useState([]);
    const [maxdiscount, setmaxdiscount] = useState(0);
    const [renderLimit, setRenderLimit] = useState(10);

    useDocumentTitle(webSettings.FULL_NAME);

    // Shuffle once and keep full list
    const shuffledCategories = React.useMemo(() => {
        if (!categories || categories.length === 0) return [];
        return _.shuffle(categories);
    }, [categories]);

    useEffect(() => {
        window.scroll({ top: 0, behaviour: 'smooth' });
        loadtopselling()
    }, [locationData?.mainLocation]);

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            return <span>Ended</span>;
        } else {
            return <span> {hours}h :{minutes}m :{seconds}s</span>;
        }
    };




    useEffect(() => {
        if (categories) {
            if (categories?.length > 11) {
                setCategoriesGroups(_.chunk(categories, 10));
            } else {
                setCategoriesGroups([categories]);
            }
        }
    }, [categories]);

    //fetch top selling products
    function loadtopselling() {
        fetch
            .get('getTodaysDeals', { location: locationData?.mainLocation })
            .then((res) => {
                if (res.list?.length > 0) {
                    gethighestpercentage(res.list)
                    settopSellingProducts(res.list)
                } else {
                    fetch
                        .get('getTopSellingProducts', { location: locationData?.mainLocation })
                        .then((res) => {
                            gethighestpercentage(res.list)
                            settopSellingProducts(res.list)
                        })
                }
            })
    }



    // Get highest percentage
    const gethighestpercentage = (array) => {
        if (array?.length > 0) {
            array.forEach(element => {
                element.discount = element?.amount_value ? Math.round(((parseFloat(element?.amount_value) - parseFloat(element.promotion_price)) / parseFloat(element?.amount_value)) * 100) : 0
            });

            const highestPercentage = Math.max(...array.map(o => o.discount));
            setmaxdiscount(highestPercentage);
        } else {
            setmaxdiscount(10)
        }
    };



    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={[]} />}
            <Universalheader onshowsearchbar={() => setshowsearchbar(true)} />
            <div>
                <div className="wraphomesliders">
                    <Homesliders sliders={sliders} />
                </div>

                {/* <div className='wrapcategoriesslider'>
                    <Categoriesslider categories={categoriesToView} />
                </div> */}
                {recentlyViewed?.length > 0 &&
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <h3>Recently Viewed</h3>
                            <Button onClick={() => navigate('/recents')} >SEE ALL</Button>
                        </section>
                        <Productsfour products={recentlyViewed} showoffer={true} />
                    </div>}
                {recentlySearched?.length > 0 &&
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <h3>Last Searched</h3>
                            <Button onClick={() => navigate('/lastsearched')} >SEE ALL</Button>
                        </section>
                        <Productsfour products={recentlySearched} showoffer={true} />
                    </div>}
                <div className="sections">
                    <section className="flashsaleheader">
                        <div className="flashsaleleft">
                            <BoltOutlined sx={{ color: "orange" }} />
                            <div>
                                <div style={{ fontWeight: "bold" }}>Flash sales</div>
                                <div style={{ display: "flex", fontSize: 15, justifyContent: "center", alignItems: "center" }}>
                                    TIME LEFT: &nbsp;
                                    <div style={{ fontWeight: "bold", fontSize: 14 }}>
                                        <Countdown
                                            date={Date.now() + diff}
                                            renderer={renderer}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Button color="secondary" onClick={() => navigate("/todays-deals")} endIcon={<ChevronRight />}>View All</Button>
                    </section>
                    <ProductSlider products={topSellingProducts} showquantity={true} showoffer={true} />
                </div>

                {homeCategories.map((category, key) => (
                    <MobileCategorySection
                        key={key}
                        category={category}
                        minProducts={2}
                        onInvalid={() => setRenderLimit(prev => Math.min(prev + 1, homeCategories.length))}
                    />
                ))}

                {favorites?.length > 0 &&
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <h3>Saved Items</h3>
                            <Button onClick={() => navigate('/saveditems')} >SEE ALL</Button>
                        </section>
                        <Productsfour products={favorites} showoffer={true} />
                    </div>}

            </div>
        </div>
    )
}

export default Home